import { html, isInteger, removeClasses, Direction } from './utils';
import { ClueListItem } from './models';
import { TRANSLATION_TABLE } from './app';

type Clue = HTMLLIElement;

export function render(root: HTMLElement, clues: ClueListItem[]): HTMLElement {
  let wrapper: HTMLElement;
  let horizontal: HTMLElement;
  let vertical: HTMLElement;

  [wrapper, horizontal, vertical] = Elements.wrapper();

  clues.forEach((clue: ClueListItem) => {
    if (Direction.aligns(Direction.Horizontal, clue.clue.direction)) {
      horizontal.appendChild(Elements.clue(clue));
    } else if (Direction.aligns(Direction.Vertical, clue.clue.direction)) {
      vertical.appendChild(Elements.clue(clue));
    }
  });

  root.appendChild(wrapper);
  root.addEventListener('wordcross:select', (event: CustomEvent) => {
    highlight(wrapper, event);
  }, false);

  return wrapper;
}

function highlight(root: HTMLElement, event: CustomEvent): void {
  let element: HTMLElement;
  let clue: number;

  removeClasses(root, '.selected', ['selected']);

  clue = event.detail.clue;
  if (isInteger(clue)) {
    element = <HTMLElement>root.querySelector('[data-id="' + clue + '"]');
    if (element !== null) {
      element.classList.add('selected');
    }
  }
}

module Elements {
  export function wrapper(): HTMLElement[] {
    let wrapper: HTMLDivElement;
    let wrapperVertical: HTMLDivElement;
    let wrapperHorizontal: HTMLDivElement;
    let horizontal: HTMLOListElement;
    let vertical: HTMLOListElement;

    wrapper = <HTMLDivElement>html('div', ['wc-clue-list-wrapper']);

    wrapperVertical = <HTMLDivElement>html('div', ['wc-clue-list-vertical']);
    wrapperVertical.appendChild(Elements.heading(TRANSLATION_TABLE['Down']));
    wrapperHorizontal = <HTMLDivElement>html('div', ['wc-clue-list-horizontal']);
    wrapperHorizontal.appendChild(Elements.heading(TRANSLATION_TABLE['Across']));

    horizontal = <HTMLOListElement>html('ol', ['wc-clue-list']);
    vertical = <HTMLOListElement>html('ol', ['wc-clue-list']);

    wrapperHorizontal.appendChild(horizontal);
    wrapperVertical.appendChild(vertical);

    wrapper.appendChild(wrapperHorizontal);
    wrapper.appendChild(wrapperVertical);

    return [wrapper, horizontal, vertical];
  }

  export function heading(title: string): HTMLHeadingElement {
    let heading: HTMLHeadingElement = <HTMLHeadingElement>html('h2');
    heading.textContent = title;
    return heading;
  }

  export function clue(c: ClueListItem): Clue {
    let el: Clue = <Clue>html('li');

    el.textContent = c.clue.clue;
    el.setAttribute('data-id', c.clue.id.toString());
    el.setAttribute('data-number', c.number.toString());
    el.setAttribute('data-length', c.clue.length.toString());
    return el;
  }
}
